import React from 'react';
import { Route, Switch } from 'react-router-dom';
import BillPostingSettingsPage from '../Pages/BillPostingSettings/BillPostingSettingsPage';

/**
 * Routes for Bill Posting Settings
 * @param {Object} props - Component props
 * @returns {JSX.Element} BillPostingSettingsRoutes component
 */
const BillPostingSettingsRoutes = (props) => {
  const { match } = props;
  const { path } = match;
  
  return (
    <Switch>
      <Route exact path={`${path}`} component={BillPostingSettingsPage} />
    </Switch>
  );
};

export default BillPostingSettingsRoutes;
